// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__xUlI8","question":"styles_question__TMFal","description":"styles_description__26W7K"};